import { render, staticRenderFns } from "./BaseBottomModal.vue?vue&type=template&id=16f099a8&"
import script from "./BaseBottomModal.vue?vue&type=script&lang=ts&"
export * from "./BaseBottomModal.vue?vue&type=script&lang=ts&"
import style0 from "./BaseBottomModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports